import React, { useState } from "react";
import { Link } from "react-router-dom";

function Main() {
  const [ytshow, setytShow] = useState(false);

  const phoneNumber = "96160402090";

  const whatsappUrl = `https://wa.me/${phoneNumber}`;
  const locationLink =
    "https://www.google.com/maps/place/Eden+lake+view/@34.3343171,35.8825768,17z/data=!4m14!1m7!3m6!1s0x1521f83aff8ad7ed:0x978f3d40dfcc95f3!2sEden+lake+view!8m2!3d34.3343171!4d35.8851517!16s%2Fg%2F11c1rfn2lh!3m5!1s0x1521f83aff8ad7ed:0x978f3d40dfcc95f3!8m2!3d34.3343171!4d35.8851517!16s%2Fg%2F11c1rfn2lh?entry=ttu";
  const facebookLink = "https://www.facebook.com/edenrestaurantt";
  const instagramLink = "https://www.instagram.com/eden.resto/";

  return (
    <>
      <footer>
        <div className="container">
          <div className="foote_widget contact_info">
            <div className="row ">
              <div className="col-md-7 direction_block">
                <p>
                  <a
                    className="btn_text"
                    href={locationLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={require("../../assets/images/icon-location.png")}
                      alt="img"
                    />
                    Lake Bnachii Street, Zgharta Lebanon
                  </a>
                  <br />
                  <div className="booking-container">
                    <img
                      src={require("../../assets/images/icon-phone.png")}
                      alt="img"
                    />
                    Booking :{" "}
                    <a
                      className="btn_text"
                      href={whatsappUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +961 70 402 090
                    </a>
                  </div>
                </p>
              </div>
              {/* <div className="col-md-5 text-md-right timing_block">
                <p>
                  Monday - Friday : 8AM - 9PM <br />
                  Saturday - Sunday : 8AM - 11PM
                </p>
                <Link
                  to="#"
                  className="btn btn_primary mt-3"
                  id="bookingForm_modelTitle"
                  data-toggle="modal"
                  data-target="#bookingForm_model"
                  onClick={() => setytShow(true)}
                >
                  book a table
                </Link>
              </div> */}
            </div>
          </div>
          <div className="foote_widget newsletter_block">
            <div className="row py_50">
              <div className="col-md-7 offer_block">
                {/* <h2>Get News &amp; Offers</h2>
                <p>
                  Subscribe us &amp; Get <span>25% Off.</span>
                </p> */}
                {/* <form>
                  <div className="form-group">
                    <span className="icon position-absolute">
                      <i className="icofont-envelope-open" />
                    </span>
                    <input
                      type="text"
                      placeholder="Your email"
                      className="form-control"
                      required=""
                    />
                    <button className="btn btn_primary">subscribe now</button>
                  </div>
                </form> */}
              </div>
              <div className="col-md-5">
                <ul className="social_media">
                  <li>
                    <a href={facebookLink} target="_blank" rel="noreferrer">
                      <img
                        src={require("../../assets/images/icon-facebook.png")}
                        alt="img"
                      />
                    </a>
                  </li>
                  <li>
                    <a href={instagramLink} rel="noreferrer" target="_blank">
                      <img
                        src={require("../../assets/images/icon-instagram.png")}
                        alt="img"
                      />
                    </a>
                  </li>
                  {/* <li>
                    <a href="https://twitter.com/" target="_blank">
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/" target="_blank">
                      Youtube
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          {/* <div className="foote_widget menu_links">
            <div className="row">
              <div className="col-md-12">
                <ul className="links d-flex justify-content-center">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/menulist1">Menu 1</Link>
                  </li>
                  <li>
                    <Link to="/menulist2">Menu 2</Link>
                  </li>
                  <li>
                    <Link to="/menulist3">Menu 3</Link>
                  </li>
                  <li>
                    <Link to="/about">About us</Link>
                  </li>
                  <li>
                    <Link to="/ourchef">Our chefs</Link>
                  </li>
                  <li>
                    <Link to="/bloglist">Blog</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="col-md-12 copy_right text-center">
              <p>
                © 2024 Restaurant. All Rights Reserved | Crafted by{" "}
                <Link
                  // to="https://themeforest.net/user/kalanidhithemes"
                  target="blog-list"
                >
                  Andre Mawad
                </Link>
              </p>
            </div>
          </div>
        </div>
        <div className="go_top" id="Gotop">
          <span>
            <i className="icofont-rounded-up" />
          </span>
        </div>
      </footer>
      {ytshow && (
        <div
          className="modal fade booking_model show"
          id="bookingForm_model"
          tabIndex={-1}
          aria-labelledby="bookingForm_modelTitle"
          style={{ display: "block", paddingRight: 17 }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header text-center border-0 d-block p-0">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setytShow(false)}
                >
                  <span aria-hidden="true">
                    <i className="icofont-close-line" />
                  </span>
                </button>
                <h2 className="mb-2">Online Reservation</h2>
                <p>
                  Booking request <a href="tel:+88123123456">+88-123-123456</a>{" "}
                  or fill out the order form
                </p>
              </div>
              <div className="modal-body">
                <div className="booking_form">
                  <form>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Name"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Phone Number"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <span className="icon">
                            <i className="icofont-user-alt-7" />
                          </span>
                          <input
                            type="text"
                            className="form-control has_icon"
                            placeholder="1 Person"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <span className="icon">
                            <i className="icofont-calendar" />
                          </span>
                          <input
                            type="date"
                            className="form-control  flex-row-reverse"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <span className="icon">
                            <i className="icofont-clock-time" />
                          </span>
                          <input
                            type="time"
                            className="form-control has_icon  flex-row-reverse pl-0"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <textarea
                            className="form-control"
                            placeholder="Message"
                            defaultValue={""}
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-12">
                        <button className="btn btn_primary w-100 ">
                          book a table
                        </button>
                      </div> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Main;

